import { TOGGLE_MODE_ENVIRONMENT } from "../actionTypes";

export const toggleModeEnvironment = (data: any) => {
  return {
    type: TOGGLE_MODE_ENVIRONMENT,
    data,
  };
};
